export default __webpack_public_path__ + "static/media/punch-sound.91ad27cb.mp3";